import { render, staticRenderFns } from "./SaraiDashboard.vue?vue&type=template&id=372dd735&scoped=true"
import script from "./SaraiDashboard.vue?vue&type=script&lang=js"
export * from "./SaraiDashboard.vue?vue&type=script&lang=js"
import style0 from "./SaraiDashboard.vue?vue&type=style&index=0&id=372dd735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372dd735",
  null
  
)

export default component.exports